(function () {
    'use strict';

    angular
        .module('app.admin')
        .controller('AdminController', AdminController);

    AdminController.$inject = ['common', 'dataservice'];
    /* @ngInject */
    function AdminController(common, dataservice) {
        var vm = this;
        vm.title = 'Admin';

        vm.alertCount = -1;
        vm.userCount = -1;
        vm.taskCount = -1;
        vm.logTypeCount = -1;
        vm.completionTypeCount = -1;
        vm.filterTypeCount = -1;
        vm.departmentCount = -1;
        vm.taskTemplateCount = -1;
        vm.alertTemplateCount = -1;
        vm.promotionalImageCount = -1;
        vm.eventDisplayCount = -1;
        vm.paymentGatewayCount = -1;
        vm.paymentTemplateCount = -1;
        vm.lostAndFoundCount = -1;
        vm.isAdmin = 0;
        vm.is7Point = is7Point;
        vm.clearCache = clearCache;
        vm.apiVersion = "Loading";
        vm.userService = common.userService;
        vm.common = common;
        vm.showFilterTypes = common.userService.apiTypeId() !== common.config.apiTypes.centersXml;
        vm.showEventDisplayTile = showEventDisplayTile;
        vm.eventDisplayAccess = [];
        vm.showiCalFeeds = showiCalFeeds;
        activate();

        function activate() {
            vm.isAdmin = common.userService.userType() == "2"
            var promises = [ getCounts(), getApiVersion(), getUserEventDisplayConfigAccess()];
            return common.$q.all(promises).then(function () {
                common.logger.info('Activated ' + vm.title + ' View');
            }, function (error) { });
        }

        

        function getApiVersion() {
            return dataservice.getItems('api/Tenants/ApiVersion').then(function (response) {
                vm.apiVersion = response.data.Message;
            }, function (error) { });
        }

        function is7Point() {
            if (common.userService.tenantId() == 1) {
                return true;
            }
            return false;
        }

        function showiCalFeeds() {
            return vm.userService.isMazevoApi() == 1;
        }

        function showEventDisplayTile() {
            if (vm.isAdmin) {
                return true;
            }

            if (common.userService.userType() === "1") {
                return vm.eventDisplayAccess && vm.eventDisplayAccess.length > 0;
            }

            return false;

        }

        function clearCache() {
            dataservice.saveItem("api/Users/ClearCache", {}, true);
        }

        function getUserEventDisplayConfigAccess() {
            dataservice.getItems("api/EventDisplay").then(function (response) {
                vm.eventDisplayAccess = response.data;
            }), function (error) { console.log(error);};
        }
        

        function getCounts() {
            
            return dataservice.getItems('api/Counts/ForAdmin').then(function (response) {
                var countModel = response.data;
                
                vm.alertCount = countModel.AlertCount.ActiveCount;
                vm.userCount = countModel.UserCount.ActiveCount;
                vm.taskCount = countModel.TaskCount.ActiveCount;
                vm.logTypeCount = countModel.LogTypeCount.ActiveCount;
                vm.completionTypeCount = countModel.CompletionTypeCount.ActiveCount;
                vm.filterTypeCount = countModel.FilterTypeCount.ActiveCount;
                vm.departmentCount = countModel.DepartmentCount.ActiveCount;
                vm.promotionalImageCount = countModel.PromotionalImageCount.ActiveCount;
                vm.eventDisplayCount = countModel.EventDisplayCount.ActiveCount;
                vm.paymentGatewayCount = countModel.PaymentGatewayCount.ActiveCount;
                vm.paymentTemplateCount = countModel.PaymentTemplateCount.ActiveCount;
                vm.lostAndFoundCount = countModel.LostAndFoundCount.ActiveCount;
                vm.taskTemplateCount = countModel.TaskTemplateCount.ActiveCount;
                vm.alertTemplateCount = countModel.AlertTemplateCount.ActiveCount;
                return vm.reservations;
            }, function (error) { });
        }
    }
})();
